import React from 'react'
import { connect } from 'react-redux'
import clone from 'lodash/clone'

import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import ClientSearchModal from './Delegates/ClientSearchModal'

import { loadClientDelegates } from '../../../../store/client'
import { translateCmd } from '../../helpers'
import { delegateClientSearchModal, addDelegateModalName } from '../../constants'
import Modals, { openDelegateDeleteModal, openDelegateViewModal } from './Delegates/Modals'
import { Delegate, RepresentativesProps, linkedFile } from '../../types'

const config = {
  gridIdentity: { formName: 'frm_client_view', objectName: 'dbgrd_delegates' },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    ADate: { valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    StartDate: { valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    EndDate: { valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    InsuranceAmount: { cellStyle: { textAlign: 'right' } },
  },

  // getContextMenuItems: () => [
  //   { name: translateCmd('edit_insurance'), action: () => {}, icon: 'edit' },
  //   { name: translateCmd('delete_insurance'), action: () => {}, icon: 'delete' },
  // ],
}

//@ts-ignore
@connect(undefined, {
  openClientSearch: () => LKModalActions.open({ name: delegateClientSearchModal }),
  openDelegateViewModal,
  openDelegateAddModal: (
    isEdit: boolean,
    client: Delegate & {
      linkedfiles?: linkedFile[]
      Full_Name?: string
    },
    linkedfiles: linkedFile[],
  ) => LKModalActions.open({ name: addDelegateModalName, isEdit, client, linkedfiles }),
  openDelegateDeleteModal,
  loadClientDelegates,
})
@withConstantPermissions([
  'CLIENT_DELEGATE_ADD as CanAdd',
  'CLIENT_DELEGATE_EDIT as CanEdit',
  'CLIENT_DELEGATE_VIEW as CanView',
  'CLIENT_DELEGATE_DELETE as CanDelete',
])
class Representatives extends React.PureComponent<RepresentativesProps, { delegates: Delegate[] }> {
  state = {
    delegates: [],
  }

  componentDidMount() {
    this.loadDelegates()
  }

  loadDelegates = async () => {
    const { ID, hash } = this.props

    const result = await this.props.loadClientDelegates({ clientId: ID, clientHash: hash })

    if (loadClientDelegates.fulfilled.match(result)) {
      this.setState({
        delegates: result.payload || [],
      })
    }
  }

  handleEditOpen = (
    delegate: Delegate & {
      linkedfiles?: linkedFile[]
      Full_Name?: string
    },
    files: linkedFile[],
  ) => {
    this.props.openDelegateAddModal(true, delegate, files)
  }

  handleAddOpen = () => {
    this.props.openClientSearch(this.props.linkedfiles)
  }

  handleViewOpen = (
    delegate: Delegate & {
      linkedfiles?: linkedFile[]
      Full_Name?: string
    },
  ) => {
    this.props.openDelegateViewModal(delegate)
  }

  handleDeleteOpen = (
    delegate: Delegate & {
      linkedfiles?: linkedFile[]
      Full_Name?: string
    },
  ) => {
    const { ID, hash } = this.props

    this.props.openDelegateDeleteModal(
      ID,
      hash,
      delegate.RLClientID,
      delegate.HashSum_RLClientID_,
      delegate.ID,
      delegate.HashSum_DelegateID_,
    )
  }

  getContextMenuItems = (params: { node: { data: Delegate & { linkedfiles?: linkedFile[]; Full_Name?: string } } }) => {
    const {
      node: { data },
    } = params

    const row = clone(data)
    row.linkedfiles = this.props.linkedfiles
    row.Full_Name = row.FullName

    return [
      {
        type: 'title',
        name: row.FullName,
      },

      ...(this.props.selector
        ? [
            {
              name: 'finish',
              action: () => this.props.onSelect(row),
              icon: 'hand',
            },
          ]
        : [
            {
              name: translateCmd('mon_view'),
              action: () => this.handleViewOpen(row),
              icon: 'info',
              permissionKey: 'CLIENT_DELEGATE_VIEW',
            },

            this.props.CanEdit
              ? {
                  name: translateCmd('edit_client'),
                  icon: 'edit',
                  action: () => this.handleEditOpen(row, this.props.linkedfiles),
                  disabled: !this.props.CanEdit,
                  permissionKey: 'CLIENT_DELEGATE_EDIT',
                }
              : undefined,

            this.props.CanDelete
              ? {
                  name: translateCmd('client_rl_del'),
                  icon: 'delete',
                  disabled: !this.props.CanDelete,
                  action: () => this.handleDeleteOpen(row),
                  permissionKey: 'CLIENT_DELEGATE_DELETE',
                }
              : undefined,

            'excelExport',
          ].filter((x) => x !== undefined)),
    ]
  }

  render = () => {
    const { delegates } = this.state
    const { instanceName, ID, hash, linkedfiles, CanAdd } = this.props

    return (
      <div className="u-flex u-fluid u-directionColumn">
        <ClientSearchModal linkedfiles={linkedfiles} clientId={ID} clientHash={hash} />
        {/* @ts-ignore */}
        <Modals ID={ID} hash={hash} />
        <div className="u-fluid u-relative">
          <LKGrid
            rowData={delegates}
            {...config}
            instanceName={instanceName}
            getContextMenuItems={this.getContextMenuItems}
          />
        </div>

        {CanAdd && (
          <div className="u-padding-5">
            <LKButton alias="add" size="tiny" style={{ float: 'right' }} onClick={this.handleAddOpen}>
              {translateCmd('client_rl_add')}
            </LKButton>
          </div>
        )}
      </div>
    )
  }
}

;(Representatives as any).defaultProps = {
  data: [],
}

export default Representatives
